<template>
  <div style="overflow-x: hidden;">
    <el-row :gutter="16">
      <el-col :span="12"
              style="animation-duration: 500ms"
              :class="{ animate__animated: true, animate__slideInLeft: isIn, animate__slideOutLeft: isOut }">
        <el-row :gutter="16">
          <el-col :span="8">
            <div class="small_container"
                 style="margin-bottom:16px">
              <span class="title">总览信息</span>
              <div style="margin-top:56px;padding-left:16px;padding-right:16px">
                <el-row class="content"
                        style="margin-bottom:24px">
                  <el-col :span="12"
                          style="text-align:center">
                    <div class="esh1">接入{{outlineData.orgData.orgDataUserName}}</div>
                    <div class="esh2"
                         style="color:#ddd">
                      {{outlineData.orgData.orgDataUserValue}}
                    </div>
                  </el-col>
                  <el-col :span="12"
                          style="text-align:center">
                    <div class="esh1">接入{{outlineData.orgData.orgDataAssetName}}</div>
                    <div class="esh2"
                         style="color:#ddd">
                      {{outlineData.orgData.orgDataAssetValue}}
                    </div>
                  </el-col>
                </el-row>
                <el-row class="content"
                        style="margin-bottom:24px">
                  <el-col :span="12"
                          style="text-align:center">
                    <div class="esh1">接入设备</div>
                    <div class="esh2"
                         style="color:#ddd">
                      {{outlineData.assetCount}}
                    </div>
                  </el-col>
                  <el-col :span="12"
                          style="text-align:center">
                    <div class="esh1">现场人员</div>
                    <div class="esh2"
                         style="color:#ddd">
                      {{outlineData.userCount}}
                    </div>
                  </el-col>
                </el-row>
                <el-row class="content">
                  <el-col :span="12"
                          style="text-align:center">
                    <div class="esh1">涵盖系统</div>
                    <div class="esh2"
                         style="color:#ddd">
                      {{outlineData.systemCount}}
                    </div>
                  </el-col>
                  <el-col :span="12"
                          style="text-align:center">
                    <div class="esh1">知识总数</div>
                    <div class="esh2"
                         style="color:#ddd">
                      {{outlineData.knowledgeCount}}
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>
          <el-col :span="16">
            <div class="middle_container"
                 style="margin-bottom:16px;cursor: pointer;"
                 @click="go_fault">
              <span class="title">整体评估</span>
              <el-row style="margin-top:32px;padding-left:16px;padding-right:16px">
                <el-col :span="10"
                        :offset="1">
                  <el-row class="content">
                    <el-col>
                      <div id="score_panel"
                           style="width:100%;height:250px;"></div>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="2"
                        style="text-align: center;">
                  <img src="../../assets/imgs/dashboard/separator2x315.png"
                       style="height:240px" />
                </el-col>
                <el-col :span="10">
                  <el-col :span="24"
                          style="text-align:center;font-weight:bold;color:#ff4500;font-size:20px;padding-top:16px">
                    <span>当前故障</span>
                    <br><span style="font-size:14px;">{{outlineData.nofinishFaults==null?0:outlineData.nofinishFaults.length}}</span>
                  </el-col>
                  <el-col :span="12"
                          style="text-align:center;font-weight:bold;color:#ff4500;font-size:16px;padding-top:24px">
                    <span>当日发生</span>
                    <br><span style="font-size:14px;">{{outlineData.todayOccuCount}}</span>
                  </el-col>
                  <el-col :span="12"
                          style="text-align:center;font-weight:bold;color:#59f2ff;font-size:16px;padding-top:24px">
                    <span>当日处理</span>
                    <br><span style="font-size:14px;color:#ddd">{{outlineData.todaySolveCount}}</span>
                  </el-col>
                  <el-col :span="12"
                          style="text-align:center;font-weight:bold;color:#ff4500;font-size:16px;padding-top:24px">
                    <span>当月发生</span>
                    <br><span style="font-size:14px;">{{outlineData.thisMonthOccuCount}}</span>
                  </el-col>
                  <el-col :span="12"
                          style="text-align:center;font-weight:bold;color:#59f2ff;font-size:16px;padding-top:24px">
                    <span>当月处理</span>
                    <br><span style="font-size:14px;color:#ddd">{{outlineData.thisMonthSolveCount}}</span>
                  </el-col>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col>
            <div class="big_container"
                 style="margin-bottom:16px;cursor: pointer;">
              <span class="title">巡检信息</span>
              <el-row>
                <el-col :span="6">
                  <el-row class="content"
                          style="margin-bottom:12px;margin-top:40px;text-align:center">
                    <el-col :span="12"
                            style="text-align:center">
                      <div class="esh1">当日巡检项</div>
                      <div class="esh2"
                           style="color:#ddd">
                        {{insData.todayPlanItemCount}}
                      </div>
                    </el-col>
                    <el-col :span="12"
                            style="text-align:center">
                      <div class="esh1">已完成</div>
                      <div class="esh2"
                           style="color:#ddd">
                        {{insData.todayFinishPlanItemCount}}
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col>

                      <div id="finish_rate_panel"
                           style="width:100%;height:150px"></div>

                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="1"
                        style="text-align: center;padding-top:30px;position: relative;">
                  <!-- <span style="position:absolute;color:#ddd;left:0px;top:100px">日<br>统<br>计</span> -->
                  <!-- <img src="../../assets/imgs/dashboard/separator2x315.png"
                       style="height:240px;position:absolute;left:20px" /> -->
                  <!-- <span style="position:absolute;color:#ddd;left:26px;top:100px">月<br>统<br>计</span> -->
                  <img src="../../assets/imgs/dashboard/separator2x315.png"
                       style="height:240px;" />
                </el-col>
                <el-col :span="3">
                  <el-row class="content"
                          style="margin-bottom:12px;margin-top:40px">
                    <el-col style="text-align:center">
                      <div class="esh1">巡检线路</div>
                      <div class="esh2"
                           style="color:#ddd">
                        {{insData.lineCount}}
                      </div>
                    </el-col>
                  </el-row>
                  <el-row class="content"
                          style="margin-bottom:12px">
                    <el-col style="text-align:center">
                      <div class="esh1">巡检计划</div>
                      <div class="esh2"
                           style="color:#ddd">
                        {{insData.planCount}}
                      </div>
                    </el-col>
                  </el-row>
                  <el-row class="content"
                          style="margin-bottom:12px">
                    <el-col style="text-align:center">
                      <div class="esh1">巡检项</div>
                      <div class="esh2"
                           style="color:#ddd">
                        {{insData.planItemCount}}
                      </div>
                    </el-col>
                  </el-row>
                  <el-row class="content">
                    <el-col style="text-align:center">
                      <div class="esh1">逾期计划</div>
                      <div class="esh2"
                           style="color:#ddd">
                        {{insData.planLateCount}}
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="7">
                  <div id="ins_plan_dis_panel"
                       style="width:100%;height:300px;"></div>
                </el-col>
                <el-col :span="7"
                        style="padding-top:48px">
                  <div id="ontime_rate_panel"
                       style="width:100%;height:220px"></div>
                </el-col>

              </el-row>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="8">
            <div class="small_container"
                 style="margin-bottom:16px">
              <span class="title">保养统计</span>
              <div class="content"
                   style="margin-top:40px;">
                <el-row>
                  <el-col :span="12"
                          style="text-align:center">
                    <div class="esh2">当日保养</div>
                    <div class="esh2"
                         style="color:#ddd">
                      {{maintainData.todayMaintainCount}}
                    </div>
                  </el-col>
                  <el-col :span="12"
                          style="text-align:center">
                    <div class="esh2">当日完成</div>
                    <div class="esh2"
                         style="color:#ddd">
                      {{maintainData.todayFinishMaintainCount}}
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12"
                          style="text-align:center">
                    <div class="esh2">当月保养</div>
                    <div class="esh2"
                         style="color:yellow">
                      {{maintainData.thisMonthMaintainCount}}
                    </div>
                  </el-col>
                  <el-col :span="12"
                          style="text-align:center">
                    <div class="esh2">当月完成</div>
                    <div class="esh2"
                         style="color:#dddddd">
                      {{maintainData.thisMonthFinishMaintainCount}}
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <div id="maintain_ontime_rate_panel"
                         style="width:100%;height:160px;position: relative;top:-20px"></div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="small_container"
                 style="margin-bottom:16px;cursor: pointer;">
              <span class="title">任务统计</span>
              <div class="content"
                   style="margin-top:40px;">
                <el-row>
                  <el-col :span="12"
                          style="text-align:center">
                    <div class="esh2">当日任务</div>
                    <div class="esh2"
                         style="color:#ddd">
                      {{taskData.todayTaskCount}}
                    </div>
                  </el-col>
                  <el-col :span="12"
                          style="text-align:center">
                    <div class="esh2">当日完成</div>
                    <div class="esh2"
                         style="color:#ddd">
                      {{taskData.todayFinishTaskCount}}
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12"
                          style="text-align:center">
                    <div class="esh2">当月任务</div>
                    <div class="esh2"
                         style="color:yellow">
                      {{taskData.thisMonthTaskCount}}
                    </div>
                  </el-col>
                  <el-col :span="12"
                          style="text-align:center">
                    <div class="esh2">当月完成</div>
                    <div class="esh2"
                         style="color:#dddddd">
                      {{taskData.thisMonthFinishTaskCount}}
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <div id="task_ontime_rate_panel"
                         style="width:100%;height:160px;position: relative;top:-20px"></div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="small_container"
                 style="margin-bottom:16px;cursor: pointer;"
                 @click="go_repair">
              <span class="title">维修统计</span>
              <el-row style="margin-top:40px">
                <el-col :span="24"
                        style="text-align:center;font-weight:bold;color:#ff4500;font-size:20px;padding-top:16px">
                  <span>当前维修</span>
                  <br><span style="font-size:14px;">{{outlineData.nofinishRepairs}}</span>
                </el-col>
                <el-col :span="12"
                        style="text-align:center;font-weight:bold;color:#ff4500;font-size:16px;padding-top:24px">
                  <span>当日发生</span>
                  <br><span style="font-size:14px;">{{outlineData.todayOccuCountRepair}}</span>
                </el-col>
                <el-col :span="12"
                        style="text-align:center;font-weight:bold;color:#59f2ff;font-size:16px;padding-top:24px">
                  <span>当日处理</span>
                  <br><span style="font-size:14px;color:#ddd">{{outlineData.todaySolveCountRepair}}</span>
                </el-col>
                <el-col :span="12"
                        style="text-align:center;font-weight:bold;color:#ff4500;font-size:16px;padding-top:24px">
                  <span>当月发生</span>
                  <br><span style="font-size:14px;">{{outlineData.thisMonthOccuCountRepair}}</span>
                </el-col>
                <el-col :span="12"
                        style="text-align:center;font-weight:bold;color:#59f2ff;font-size:16px;padding-top:24px">
                  <span>当月处理</span>
                  <br><span style="font-size:14px;color:#ddd">{{outlineData.thisMonthSolveCountRepair}}</span>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="12"
              style="animation-duration: 500ms"
              :class="{ animate__animated: true, animate__slideInRight: isIn, animate__slideOutRight: isOut }">
        <el-row>
          <el-col>
            <div class="fat_container">
              <span class="title">实时故障信息</span>
              <el-carousel height="580px"
                           style="margin-top:36px;"
                           direction="vertical"
                           :interval="5000">
                <el-carousel-item v-for="item in nofinishFaults"
                                  :key="item.id">
                  <div class="c_alarm_panel"
                       style="cursor: pointer;"
                       v-for="ele in item"
                       :key="ele.id"
                       @click="go_fault_detail(ele.id,ele.code)">
                    <table style="width:100%;">
                      <tr>
                        <td rowspan="2"
                            width="110px">
                          <div class="alarm_1">{{ele.level_name}}</div>
                        </td>
                        <td align="left"
                            style="color:#ddd;font-size:16px;padding-top:10px"><span>{{ ele.org_name+'>'+ele.area_name+'>'+ele.equi_name }}</span>
                          <el-tag size="mini"
                                  type="danger"
                                  effect="dark"
                                  style="margin-left:4px"
                                  v-if="ele.process!=null&&ele.process.startsWith('挂起')">挂起</el-tag>
                        </td>
                        <td align="right"
                            style="color:#ddd;font-size:14px;padding-right:8px;padding-top:10px">上报时间：{{ ele.occu_time.replace('T',' ').substring(0,16) }}</td>
                      </tr>
                      <tr>
                        <td align="left"><span>{{'【'+ele.code+'】'+ ele.appe_name+(ele.des==null?'':('：'+ele.des)) }}</span></td>
                        <td align="right"
                            style="font-size:14px;padding-right:8px">上报人：{{ ele.reporte_name }}</td>
                      </tr>
                    </table>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <div class="big_container"
                 style="cursor: pointer;"
                 @click="go_fault">
              <span class="title">近30日故障曲线</span>
              <el-row style="cursor: pointer;">
                <div id="days_alarm_panel"
                     @click="go_fault"
                     style="width:100%;height:300px;margin-left:12px;margin-right:12px;"></div>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <div style="animation-duration: 500ms;"
         class="model_panel"
         v-if="viewFaultVisible"
         :class="{ frame:true,animate__animated: true, animate__bounceInDown: contentIsIn, animate__bounceOutUp: contentIsOut}">
      <div class="model_large"
           style="color: #59f2ff;">
        <el-button icon="el-icon-close"
                   class="close"
                   circle
                   type="danger"
                   size="large"
                   @click="colseFaultDetail"></el-button>
        <div class="model-title">{{faultInfo.code}}</div>
        <div class="model-content">
          <el-row>
            <el-col :span="8"
                    style="margin-bottom:12px">
              组织：{{faultInfo.orgName}}
            </el-col>
            <el-col :span="8"
                    style="margin-bottom:12px">
              区域：{{faultInfo.areaName}}
            </el-col>
            <el-col :span="8"
                    style="margin-bottom:12px">
              设备：{{faultInfo.equiName}}
            </el-col>
            <el-col :span="8"
                    style="margin-bottom:12px">
              设备类型：{{faultInfo.equiTypeName}}
            </el-col>
            <el-col :span="8"
                    style="margin-bottom:12px">
              设备型号：{{faultInfo.equiModelName}}
            </el-col>
            <el-col :span="8"
                    style="margin-bottom:12px">
              所属系统：{{faultInfo.systemName}}
            </el-col>
            <el-col :span="8"
                    style="margin-bottom:12px">
              故障现象：{{faultInfo.appeName}}
            </el-col>
            <el-col v-if="faultInfo.des!=null&&faultInfo.des!=''"
                    :span="8"
                    style="margin-bottom:12px">
              故障描述：{{faultInfo.des}}
            </el-col>
            <el-col :span="8"
                    style="margin-bottom:12px">
              故障等级：{{faultInfo.levelName}}
            </el-col>
            <el-col :span="8"
                    style="margin-bottom:12px">
              上报时间：{{faultInfo.occuTime}}
            </el-col>
            <el-col :span="8"
                    style="margin-bottom:12px">
              上报人：{{faultInfo.reporteName}}
            </el-col>
            <el-col :span="8"
                    style="margin-bottom:12px">
              故障状态：{{stateFormat(faultInfo.state)}}
            </el-col>
            <el-col :span="8"
                    v-if="faultInfo.state==2"
                    style="margin-bottom:12px">
              责任人：{{faultInfo.resolverName}}
            </el-col>
            <el-col :span="8"
                    style="margin-bottom:12px">
              是否提交专工：{{faultInfo.isProf==0?'否':'是'}}
            </el-col>
            <el-col :span="8"
                    style="margin-bottom:12px">
              是否曾经激活：{{faultInfo.isActived==0?'否':'是'}}
            </el-col>
            <!-- 扩展字段 -->
            <el-col v-for="item in extendDataReport"
                    :key="item.id"
                    :span="8"
                    style="margin-bottom:12px">
              {{item.label}}：{{item.value}}
            </el-col>
          </el-row>
          <es-img :info="faultInfo"
                  :fileList="fileListView"
                  type="view"></es-img>
          <template v-if="faultInfo.state==3">
            <el-divider><span style="color:#409eff">解决信息</span></el-divider>
            <el-row>
              <el-col :span="8"
                      style="margin-bottom:12px">
                解决方案：{{faultInfo.solutionName}}
              </el-col>
              <el-col :span="8"
                      style="margin-bottom:12px">
                方案描述：{{faultInfo.solutionDes}}
              </el-col>
              <el-col v-if="faultInfo.measures!=null&&faultInfo.measures!=''"
                      :span="8"
                      style="margin-bottom:12px">
                解决措施：{{faultInfo.measures}}
              </el-col>
              <el-col :span="8"
                      style="margin-bottom:12px">
                解决人：{{faultInfo.resolverName}}
              </el-col>
              <el-col :span="8"
                      style="margin-bottom:12px">
                解决时间：{{faultInfo.solveTime}}
              </el-col>
              <el-col v-if="faultInfo.companionName!=null&&faultInfo.companionName!=''"
                      :span="8"
                      style="margin-bottom:12px">
                协作人员：{{faultInfo.companionName}}
              </el-col>
              <!-- 扩展字段 -->
              <el-col v-for="item in extendDataSolve"
                      :key="item.id"
                      :span="8"
                      style="margin-bottom:12px">
                {{item.label}}：{{item.value}}
              </el-col>
            </el-row>
            <es-img :info="faultInfo"
                    :fileList="fileListView2"
                    type="view"></es-img>
          </template>
          <template v-if="matConsume!=null&&matConsume.length>0">
            <el-divider><span style="color:#409eff">材料信息</span></el-divider>
            <table style="width:100%;">
              <tr>
                <td><b>材料类型</b></td>
                <td><b>材料型号</b></td>
                <td><b>数量</b></td>
                <td><b>单位</b></td>
                <td><b>材料编码</b></td>
              </tr>
              <tr v-for="item in matConsume"
                  :key="item.id">
                <td>{{item.matTypeName}}</td>
                <td>{{item.matModelName}}</td>
                <td>{{item.quantity}}</td>
                <td>{{item.unit}}</td>
                <td>{{item.matNumber}}</td>
              </tr>
            </table>
          </template>
          <el-divider><span style="color:#409eff">过程信息</span></el-divider>
          <table style="width:100%;">
            <tr>
              <td><b>操作人</b></td>
              <td><b>动作</b></td>
              <td><b>被操作人</b></td>
              <td><b>时间</b></td>
            </tr>
            <tr v-for="item in activities"
                :key="item.id">
              <td>{{item.senderName}}</td>
              <td>{{item.des}}</td>
              <td>{{item.receiverName}}</td>
              <td>{{item.createTime}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cuspie from '../chart/cuspie.js'
import cuspie2 from '../chart/cuspie2.js'
export default {
  name: 'dashboardoutline',
  props: {},
  data () {
    return {
      isIn: true,
      isOut: false,
      contentIsIn: true,
      contentIsOut: false,
      outlineData: { orgData: {} },
      nofinishFaults: [],
      insData: { planSysDis: [] },
      taskData: {},
      maintainData: {},
      viewFaultVisible: false,
      faultInfo: {},
      fileListView: [],
      fileListView2: [],
      extendDataReport: {},
      extendDataSolve: {},
      activities: [],
      matConsume: []
    }
  },

  methods: {
    init () {
      this.loadOutlineData()
      this.loadDaysFaults()
      this.loadInsData()
      this.loadTaskData()
      this.loadMaintainData()
    },
    loadOutlineData () {
      this.$ajax.get('/buss/dashboard/get_outlinedata').then((msg) => {
        this.outlineData = msg

        let tempfaus = []
        let tempfaus1 = []
        let i = 0
        let j = 0
        for (let n = 0; n < msg.nofinishFaults.length; n++) {
          tempfaus1[j] = msg.nofinishFaults[n]
          j++
          if (j == 7) {
            tempfaus[i] = JSON.parse(JSON.stringify(tempfaus1))
            i++
            j = 0
            tempfaus1 = []
          }
        }
        if (j > 0) {
          tempfaus[i] = tempfaus1
        }
        this.nofinishFaults = tempfaus

        //计算总分
        let score = 0
        let fcount = this.outlineData.nofinishFaults == null ? 0 : this.outlineData.nofinishFaults.length
        if (this.outlineData.assetCount != 0) {
          score = ((this.outlineData.assetCount - fcount) * 100 / this.outlineData.assetCount).toFixed(1)
        }
        cuspie2.init('score_panel', '运维整体评分', score)

      }).catch(err => {
        this.$message.error(err)
      })
    },
    loadDaysFaults () {
      this.$ajax.get('/buss/dashboard/get_daysFaults').then((msg) => {
        let names = []
        let values = []
        msg.forEach(e => {
          names.push(e.name)
          values.push(e.value)
        })
        //近三十天故障曲线
        let daysalarmchart = this.$echarts.init(document.getElementById('days_alarm_panel'))
        let daysalarmoption = {
          xAxis: {
            type: 'category',
            data: names,
            axisLine: {
              lineStyle: {
                color: '#ddd'
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#ddd'
              }
            }
          },
          tooltip: {
            trigger: 'item',
            formatter: '<b>{b}</b><br/>{c}个'
          },
          series: [
            {
              data: values,
              type: 'line',
              smooth: true,

            }
          ]
        }
        daysalarmchart.setOption(daysalarmoption)

      }).catch(err => {
        this.$message.error(err)
      })
    },
    loadInsData () {
      this.$ajax.get('/buss/dashboard/get_ins_data').then((msg) => {
        this.insData = msg
        cuspie.init('ins_plan_dis_panel', '计划系统分布', msg.planSysDis)

        //当日巡检情况
        let finishchart = this.$echarts.init(document.getElementById('finish_rate_panel'))
        let finishoption = {
          series: [
            {
              type: 'gauge',
              radius: '100%',
              detail: {
                formatter: '{value}%',
                fontSize: 14,
                color: '#ddd'
              },
              data: [
                {
                  title: {
                    show: true,
                    fontSize: 16,
                    offsetCenter: [0, 70],
                    color: '#ddd'
                  },
                  value: msg.todayPlanItemCount == 0 ? 100 : (msg.todayFinishPlanItemCount * 100 / msg.todayPlanItemCount).toFixed(2),
                  name: '当日完成率'
                }
              ],
              axisLine:
              {
                lineStyle: {
                  color: [[0.2, '#c23531'], [0.8, '#409eff'], [1, 'green']]
                }
              }
            }
          ]
        }
        finishchart.setOption(finishoption);

        //巡检准时率
        let alarmchart = this.$echarts.init(document.getElementById('ontime_rate_panel'))
        let alarmoption = {
          series: [
            {
              type: 'gauge',
              radius: '100%',
              detail: {
                formatter: '{value}%',
                fontSize: 14,
                color: '#ddd'
              },
              data: [
                {
                  title: {
                    show: true,
                    fontSize: 16,
                    offsetCenter: [0, 80],
                    color: '#ddd'
                  },
                  value: msg.planCount == 0 ? 100 : ((msg.planCount - msg.planLateCount) * 100 / msg.planCount).toFixed(2),
                  name: '巡检准时率'
                }
              ],
              axisLine:
              {
                lineStyle: {
                  color: [[0.2, '#c23531'], [0.8, '#409eff'], [1, 'green']]
                }
              }
            }
          ]
        }
        alarmchart.setOption(alarmoption);


      }).catch(err => {
        this.$message.error(err)
      })
    },
    //任务数据
    loadTaskData () {
      this.$ajax.get('/buss/dashboard/get_task_data').then((msg) => {
        this.taskData = msg

        //当月任务准时率
        let finishchart = this.$echarts.init(document.getElementById('task_ontime_rate_panel'))
        let finishoption = {
          series: [
            {
              type: 'gauge',
              radius: '100%',
              detail: {
                formatter: '{value}%',
                fontSize: 14,
                color: '#ddd'
              },
              data: [
                {
                  title: {
                    show: true,
                    fontSize: 16,
                    offsetCenter: [0, 70],
                    color: '#ddd'
                  },
                  value: msg.thisMonthTaskCount == 0 ? 100 : ((msg.thisMonthTaskCount - msg.taskLateCount) * 100 / msg.thisMonthTaskCount).toFixed(2),
                  name: '当月准时率'
                }
              ],
              axisLine:
              {
                lineStyle: {
                  color: [[0.2, '#c23531'], [0.8, '#409eff'], [1, 'green']]
                }
              }
            }
          ]
        }
        finishchart.setOption(finishoption);
      }).catch(err => {
        this.$message.error(err)
      })
    },
    //保养数据
    loadMaintainData () {
      this.$ajax.get('/buss/dashboard/get_maintain_data').then((msg) => {
        this.maintainData = msg

        //当月准时率
        let finishchart = this.$echarts.init(document.getElementById('maintain_ontime_rate_panel'))
        let finishoption = {
          series: [
            {
              type: 'gauge',
              radius: '100%',
              detail: {
                formatter: '{value}%',
                fontSize: 14,
                color: '#ddd'
              },
              data: [
                {
                  title: {
                    show: true,
                    fontSize: 16,
                    offsetCenter: [0, 70],
                    color: '#ddd'
                  },
                  value: msg.thisMonthMaintainCount == 0 ? 100 : ((msg.thisMonthMaintainCount - msg.maintainLateCount) * 100 / msg.thisMonthMaintainCount).toFixed(2),
                  name: '当月准时率'
                }
              ],
              axisLine:
              {
                lineStyle: {
                  color: [[0.2, '#c23531'], [0.8, '#409eff'], [1, 'green']]
                }
              }
            }
          ]
        }
        finishchart.setOption(finishoption);
      }).catch(err => {
        this.$message.error(err)
      })
    },
    go_fault () {
      this.isIn = false
      this.isOut = true
      setTimeout(() => {
        this.$router.push({
          path: '/dashboardfault'
        })
      }, 500)
    },
    go_fault_detail (id, code) {
      this.contentIsIn = true
      this.contentIsOut = false
      this.viewFaultVisible = true

      this.$set(this.faultInfo, 'code', code)

      this.fileListView = []
      this.fileListView2 = []
      this.$ajax.get('/buss/fault/load_detail', { id: id }).then((msg) => {
        //初始化图片
        if (msg.attachImgs != null && msg.attachImgs != '') {
          let temp = JSON.parse(msg.attachImgs)
          temp.forEach(e => {
            this.fileListView.push(this.$api + e.url + '&platform=web&token=' + this.$store.getUser().token)
          })
        }
        if (msg.handleImgs != null && msg.handleImgs != '') {
          let temp = JSON.parse(msg.handleImgs)
          temp.forEach(e => {
            this.fileListView2.push(this.$api + e.url + '&platform=web&token=' + this.$store.getUser().token)
          })
        }
        this.faultInfo = msg

        //加载上报扩展属性
        this.$ajax.get('/buss/fault/extend_data', {
          fauId: id, typeId: 1
        }).then((msg1) => {
          this.extendDataReport = msg1
        }).catch(err => {
          this.$message.error(err)
        })
        //加载解決扩展属性
        this.$ajax.get('/buss/fault/extend_data', {
          fauId: this.faultInfo.id, typeId: 2
        }).then((msg2) => {
          this.extendDataSolve = msg2
        }).catch(err => {
          this.$message.error(err)
        })
        //过程信息
        this.$ajax.get('/buss/fault/list_fau_process', { fauId: id }).then((msg3) => {
          this.activities = msg3
        }).catch(err => {
          this.$message.error(err)
        })
        //材料信息
        this.$ajax.get('/buss/fault/list_mat_consume', { fauId: id }).then((msg4) => {
          this.matConsume = msg4
        }).catch(err => {
          this.$message.error(err)
        })
      }).catch(err => {
        this.$message.error(err)
      })
    },
    colseFaultDetail () {
      this.contentIsIn = false
      this.contentIsOut = true
      setTimeout(() => {
        this.viewFaultVisible = false
      }, 500)
    },
    go_repair () {
      this.isIn = false
      this.isOut = true
      setTimeout(() => {
        this.$router.push({
          path: '/dashboardrepair'
        })
      }, 500)
    },
    stateFormat (state) {
      if (state == 1) {
        return "待分配"
      } else if (state == 2) {
        return "待解决"
      } else {
        return "已解决"
      }
    },

  },
  mounted () {
    setTimeout(() => {
      this.init()
    }, 500)

    this.clearTimeSet = setInterval(() => {
      this.init()
    }, 30000)
  },

  beforeDestroy () {    //页面关闭时清除定时器  
    clearInterval(this.clearTimeSet);
  },

}
</script>

<style scoped>
.card_container {
  color: #59f2ff;
  font-size: 14px;
  border: 1px solid #00aeff;
  border-radius: 5px;
  box-shadow: 0 0 15px #00aeff inset;
  background-color: transparent;
  width: 100%;
  height: 100px;
  margin-top: 8px;
}
.label {
  color: #dddddd;
  font-size: 16px;
  margin: 0px;
  margin-bottom: 8px;
}
.content {
  color: #59f2ff;
  font-size: 14px;
}
.esh1 {
  font-size: 16px;
  /* font-weight: 700; */
  margin-bottom: 5px;
}
.esh2 {
  font-size: 14px;
  /* font-weight: 700; */
  margin-bottom: 5px;
}
tr {
  height: 30px;
}

.title {
  position: relative;
  color: #59f2ff;
  font-size: 14px;
  top: 18px;
  left: 32px;
}
.c_alarm_panel {
  background-color: #003548;
  width: 100%;
  height: 70px;
  color: #59f2ff;
  text-align: center;
  font-size: 14px;
  margin-bottom: 12px;
  margin-left: 18px;
  width: calc(100% - 36px);
}
.alarm_1 {
  border: 2px solid #ffa500;
  font-weight: 700;
  padding: 4px 8px 4px 8px;
  color: #ffa500;
  font-size: 12px;
  transform: rotate(-20deg);
  margin-left: 10px;
  margin-top: 12px;
  width: 60px;
}

.model-title {
  text-align: center;
  font-size: 18px;
  font-weight: bolder;
  position: relative;
  top: 10px;
  color: #ddd;
}
.model-content {
  color: #ddd;
  font-size: 14px;
  margin: 60px 80px 0px 80px;
  height: 520px;
}

.model_panel {
  position: absolute;
  z-index: 1001;
  left: 0;
  top: 0;
  width: 100%;
  height: 1080px;
  background: rgba(0, 0, 0, 0.2);
}
.model_large {
  width: 1200px;
  height: 658px;
  background: url(../../assets/imgs/dashboard/model1200x658.png) no-repeat;
  position: absolute;
  top: 200px;
  left: calc(50% - 600px);
}

.model_large .close {
  left: calc(50% + 600px);
  position: absolute;
  top: -20px;
}
</style>
